export default function init() {
    const header = document.querySelector('.site-header');

    if (header) {
        const observer = new ResizeObserver(entries => {
            const height = entries[0].contentRect.height;
            document.documentElement.style.setProperty('--header-height', `${height}px`);
        });

        observer.observe(header);
    }
}
